import React from "react";
import { Menu, Flex } from "@mantine/core";
import { CgChevronDown } from "react-icons/cg";
import { VscJson } from "react-icons/vsc";
import useModal from "src/store/useModal";
import * as Styles from "./styles";
export const OtherToolsMenu = () => {
  const setVisible = useModal(state => state.setVisible);
  return <Menu shadow="md" withArrow>
      <Menu.Target>
        <Styles.StyledOtherToolElement>
          <Flex align="center" gap={3}>
            Other Tools <CgChevronDown />
          </Flex>
        </Styles.StyledOtherToolElement>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item fz={12} leftSection={<VscJson />} component="a" href="https://transform.tuyen.blog/">
          Code Transformation Tool
        </Menu.Item>
        <Menu.Item fz={12} leftSection={<VscJson />} component="a" href="https://beautifier.tuyen.blog/">
          Code Beautifier
        </Menu.Item>
        <Menu.Item fz={12} leftSection={<VscJson />} component="a" href="https://tuyen.blog/utils/general/color-blender/">
          Color Blender
        </Menu.Item>
        <Menu.Item fz={12} leftSection={<VscJson />} component="a" href="https://it-tools.tuyen.blog/">
          IT Tools
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>;
};